import React from 'react';
import { useIntl } from 'react-intl';

import { BodyCopy } from '@xingternal/typography';

import SocialProofList from '../SocialProofList';
import OmView from '@xingternal/xing-view/OmView'; // eslint-disable-line

import { formatAmount } from '@xingternal/pages-common';

import { SocialProofUsersType } from '../../types';


import styles from './SocialProofText.css';

type getTranslationTextProps = {
  total: number | string;
  name?: string;
  proofType: string;
}

type SocialProofTextProps = {
  users: SocialProofUsersType[];
  total: number;
  proofType: string;
  pageId: string;
}

type SocialProofTextForOneProps = {
  users: SocialProofUsersType[];
  proofType: string;
}

type SocialProofTextForMultipleProps = {
  total: number;
  proofType: string;
  pageId: string;
}

const getTranslationText = ({ total, name, proofType }: getTranslationTextProps) => {
  const variant = total === 1 ? 'one' : 'other';
  const intl = useIntl();

  return intl.formatMessage(
    {
      id:
        proofType === 'EMPLOYEES'
          ? `EP_COMPANY_SOCIAL_PROOF.${variant}`
          : `EP_FOLLOWERS_SOCIAL_PROOF.${variant}`,
    },
    { username: name, numberOfContacts: total }
  );
};

const SocialProofTextForOne = ({ users, proofType }: SocialProofTextForOneProps) => {
  return (
  <>
    <a className={styles.text} href={users[0].href}>
      <BodyCopy fontWeight='bold' lineHeight='dense' size={'small'} sizeWide="medium" className={styles.noMargin}>
        {getTranslationText({
          total: 1,
          name: users[0].profileName,
          proofType,
        })}
      </BodyCopy>
    </a>
  </>
)};

const SocialProofTextForMultiple = ({ total, proofType, pageId }: SocialProofTextForMultipleProps) => {
  const intl = useIntl();
  const socialProofString = getTranslationText({
    total: formatAmount({
      value: total,
      intl,
    }),
    proofType,
  });

  return (
    <OmView
      trigger={(activateOmView: () => void) => (
        <button
          data-testid={'SOCIAL_PROOF_LIST_BUTTON'}
          onClick={activateOmView}
          className={styles.text}
        >
         <BodyCopy
            fontWeight='bold'
            lineHeight='dense'
            size={'small'}
            sizeWide="medium"
            className={styles.noMargin}
          >
            {socialProofString}
          </BodyCopy>
        </button>
      )}
    >
      <SocialProofList listTitle={socialProofString} pageId={pageId} />
    </OmView>
  );
};

const SocialProofText = ({ users, total, proofType, pageId }: SocialProofTextProps) => {
  return (
    <>
    {total === 1 && (
      <SocialProofTextForOne users={users} proofType={proofType} />
    )}
    {total > 1 && (
      <SocialProofTextForMultiple
        pageId={pageId}
        total={total}
        proofType={proofType}
      />
    )}
  </>
  )
}
 
export default SocialProofText;
